import React from "react";
import { Box } from "@mui/material";
import "./camSubHeader.scss";
import Label from "../Label/Label";

const CAMSubHeader = (props) => {
  const { text } = props;

  return (
    <Box className="cam-subheader-box">
      <Label
        className="administartor-project-title"
        text={text}
        fontSize="14px"
        fontWeight="600"
      />
    </Box>
  );
};

export default CAMSubHeader;
